import { render, staticRenderFns } from "./TabOrderSigners.vue?vue&type=template&id=5ee576be"
import script from "./TabOrderSigners.vue?vue&type=script&lang=js"
export * from "./TabOrderSigners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports